import { css } from 'styled-components';
/**
 * as a flexbox item, by default long words won't wrap unless min-width or max-width are defined
 * defining this is important to make "overflow-wrap: break-work" work correctly
 */
export const flexItemTextWrapFix = css `
  min-width: 0;
`;
